import { useEffect, useRef } from 'react';

export const useAppointmentCabainSync = ({
  appointmentById,
  form,
  cabains,
  onCabainChange,
}) => {
  const synced = useRef(false);

  useEffect(() => {
    if (synced.current) return;
    if (!cabains?.length) return;

    const cabainId =
      appointmentById?.cabain?.id || form?.getFieldValue('cabainId');

    if (!cabainId) return;

    const cabainExists = cabains.some((c) => c.id === cabainId);

    if (cabainExists) {
      onCabainChange(cabainId);
      synced.current = true;
    }
  }, [appointmentById, cabains, form, onCabainChange]);
};